import * as React from 'react';
import PunchListDesktop from './PunchListDesktop';

const PunchListMobile = (props) => {

    return (<PunchListDesktop {...props}/>)
}

export default PunchListMobile